import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import TextQuestionViewModel from '../../TextQuestionViewModel'
import Text from 'components/Text'

export default function TextValue({
  vm,
}: ValueComponentProps<TextQuestionViewModel>) {
  return <Text text={vm.toTextAnswer()} />
}
